import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "footer" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = {
  id: "footer-links",
  class: "row mb-4"
}
const _hoisted_4 = { class: "col-lg-7" }
const _hoisted_5 = {
  class: "d-flex flex-column flex-md-row align-items-center gap-3",
  autocomplete: "off"
}
const _hoisted_6 = ["onclick"]
const _hoisted_7 = {
  class: "mt-3",
  style: {"opacity":"0.7","font-size":"0.7rem"}
}
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "form-text" }, "Nuestra metodología incluye un trato cercano a medida de las necesidades de cada cliente.", -1)
const _hoisted_10 = { class: "col-lg-4 col-xl-3 offset-lg-1" }
const _hoisted_11 = { class: "list-unstyled" }
const _hoisted_12 = ["href"]
const _hoisted_13 = ["href"]
const _hoisted_14 = ["href"]
const _hoisted_15 = ["href"]
const _hoisted_16 = {
  id: "footer-copy",
  class: "small"
}
const _hoisted_17 = { class: "row align-items-lg-end" }
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"col-lg-7\"><div class=\"socials\"><a href=\"https://www.linkedin.com/company/trecupera/about/?viewAsMember=true\"><i class=\"bi bi-linkedin\"></i></a><a href=\"https://www.facebook.com/profile.php?id=100093467178409\"><i class=\"bi bi-facebook\"></i></a><a href=\"https://www.instagram.com/trecupera._/\"><i class=\"bi bi-instagram\"></i></a></div><p class=\"mb-0 mt-3 opacity-75\">© 2023 TRecupera. All Rights Reserved.</p></div>", 1)
const _hoisted_19 = { class: "col-lg-4 col-xl-3 offset-lg-1" }
const _hoisted_20 = { class: "m-0" }
const _hoisted_21 = { class: "m-0" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = ["href"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.data_.userAddress) = $event)),
              type: "text",
              class: "form-control",
              id: "floatingInputEmail",
              placeholder: "Correo electrónico"
            }, null, 512), [
              [_vModelText, $setup.data_.userAddress]
            ]),
            _createElementVNode("button", {
              onclick: () =>$setup.submit(),
              type: "button",
              class: "btn btn-sm lh-1 btn-secondary"
            }, "Contacta conmigo", 8, _hoisted_6)
          ]),
          ($setup.data_.message)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass($setup.data_.isError? 'alert alert-danger mt-1' : 'alert alert-success mt-1'),
                role: "alert"
              }, _toDisplayString($setup.data_.message), 3))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_7, [
            _createTextVNode("Al pulsar en el botón “Contacta conmigo”, consientes que los datos personales que nos facilitas sean tratados por AXACTOR ESPAÑA PLATFORM, S.A.U. como responsable del tratamiento, para contactarte y ofrecerte información sobre sus productos y servicios. Puedes ejercer los derechos establecidos en los arts. 15 a 22 del RGPD en las direcciones que encontrarás en la información adicional en nuestra "),
            _createElementVNode("a", {
              href: $setup.urlWp + '/politica-de-privacidad/'
            }, "Política de Privacidad.", 8, _hoisted_8)
          ]),
          _hoisted_9
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("ul", _hoisted_11, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: $setup.urlWp + '/aviso-legal/'
              }, "Aviso legal", 8, _hoisted_12)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: $setup.urlWp + '/politica-de-privacidad/'
              }, "Política de privacidad", 8, _hoisted_13)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: $setup.urlWp + '/politica-de-cookies/' 
              }, "Política de cookies", 8, _hoisted_14)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                href: $setup.urlWp + '/condiciones-generales-de-uso/' 
              }, "Condiciones generales de uso", 8, _hoisted_15)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("address", _hoisted_20, [
              _createElementVNode("p", _hoisted_21, [
                _createTextVNode(" C/ Doctor Esquerdo 136, 4ª Plta."),
                _hoisted_22,
                _createTextVNode(" 28007 Madrid"),
                _hoisted_23,
                _createElementVNode("a", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.phoneCall && $setup.phoneCall(...args))),
                  href: "#"
                }, "913246950"),
                _hoisted_24,
                _createElementVNode("a", {
                  href: $setup.urlWp + '#stepper'
                }, "Cómo funciona", 8, _hoisted_25),
                _hoisted_26,
                _createElementVNode("a", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.mailTo && $setup.mailTo(...args))),
                  href: "#"
                }, "info@trecupera.com")
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}